import { render, staticRenderFns } from "./EmbedFrame.vue?vue&type=template&id=b77c31d8&scoped=true&"
import script from "./EmbedFrame.vue?vue&type=script&lang=js&"
export * from "./EmbedFrame.vue?vue&type=script&lang=js&"
import style0 from "./EmbedFrame.vue?vue&type=style&index=0&id=b77c31d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c31d8",
  null
  
)

export default component.exports